import { EventEmitter } from 'events';

/* tslint:disable:jsx-wrap-multiline */
class EventSystem {

    public static event: EventEmitter;

    // tslint:disable-next-line:member-ordering
    static getInstance() {
        if (!EventSystem.event) {
            EventSystem.event = new EventEmitter();
        }
        return EventSystem.event;
    }
    
    // tslint:disable-next-line:no-any
    static on(event: string | symbol, listener: (...args: any[]) => void) {
        EventSystem.event.on(event, listener);
    }
    
    // tslint:disable-next-line:no-any
    static emit(event: string | symbol, ...args: any[]) {
        // Explicit bug fix: this dropped every extra argument (called getInstance-backed
        // .emit(event) alone), so no listener anywhere in the app could ever receive a
        // payload - confirmed no existing call site relies on this (every current
        // EventSystem.emit(...) call in the codebase passes the event name only).
        EventSystem.event.emit(event, ...args);
    }

    public constructor() {
        //  code here
    }

}

export default EventSystem;